import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";
import { FieldDataProvider } from "../../../data-provider/field.dp";
import { Field } from "../../../models/field.model";
import { DashboardDataProvider } from "../../../data-provider/dashboard.dp";
import { DashboardWidget } from "../../../models/dashboard-widget.model";
import { ChartHelper } from "../../result/chart.helper";
import { Dashboard } from "../../../models/dashboard.model";
import { CanvassStatusDataProvider } from "../../../data-provider/canvass-status.dp";
import { CanvassStatus } from "../../../models/canvass-status.model";
import { ActivityFilter } from "../../../models/activity-filter.model";
import { DashboardWidgetFilter } from "../../../models/dashboard-widget-filter.model";
import { PermissionCheck } from "../../../shared/permission";
import { USER_PERFORMANCE_TARGET_CONFIG } from "../../../utils/constants/dashboard-widget.constants";
import {
    isNewContactsMetric,
    newContactsStatsOptions,
} from "./new-contacts-metrics";

let CreateWidgetComponent = {
    selector: "vcCreateWidget",
    templateUrl:
        "/angular/components/dashboard/widget/create-widget.component.html",
    bindings: {
        dashboard: "=",
        globalFilter: "=",
        widget: "=?",
    },
    controller: class CreateWidgetController {
        // * bindings for typescript compiler *
        public dashboard: Dashboard;
        public globalFilter: DashboardWidgetFilter;
        public widget: DashboardWidget;
        // ************************************

        public accessType: string | number;
        public name: string;
        public step: number = 1;
        public customFields: Field[];
        public tableFields: any[];

        public readonly targetConfig = USER_PERFORMANCE_TARGET_CONFIG;

        public canvassStatuses: CanvassStatus[];
        public tableColumns: any;
        private dialog: DialogUtils;
        private originalWidget: DashboardWidget;
        private fieldDataProvider: FieldDataProvider;
        private dataProvider: DashboardDataProvider;
        private chartHelper: ChartHelper;

        public readonly $scope: any;
        public readonly $mdMedia: any;
        public readonly $mdDialog: any;
        public filtersOpen: boolean = false;
        public saving: boolean = false;
        public statsDataTypes: any;
        public isLeaderView: boolean = true;
        private onRouteChangeOff: any;
        private permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $mdMedia: any,
            $mdDialog: any,
            DialogUtils: DialogUtils,
            FieldDataProvider: FieldDataProvider,
            ChartHelper: ChartHelper,
            PermissionCheck: PermissionCheck,
            DashboardDataProvider: DashboardDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.$mdMedia = $mdMedia;
            this.$mdDialog = $mdDialog;
            this.dialog = DialogUtils;
            this.dataProvider = DashboardDataProvider;
            this.permissionProvider = PermissionCheck;
            this.fieldDataProvider = FieldDataProvider;
            this.chartHelper = ChartHelper;
            this.isLeaderView = __app_type == "LEADER";

            this.tableFields = this.fieldDataProvider.tableFields;

            this.fieldDataProvider.getCustomFields().then((customFields) => {
                this.customFields = customFields;

                let fieldWidgets = [];
                angular.forEach(this.customFields, (field: Field) => {
                    fieldWidgets.push({
                        name: field.name,
                        type: "customField",
                        description:
                            "A breakdown of the data captured for this field",
                    });
                });

                if (this.widget.datatype == "fields") {
                    if (this.widget.rowsField) {
                    }
                }
            });

            this.statsDataTypes = {
                interactions: [
                    { name: "Count of Interactions", value: "interactions" },
                    { name: "Doors Knocked", value: "doors_knocked" },
                    { name: "Avg. Rating", value: "avg_rating" },
                    { name: "Conversion Rate", value: "conversion_rate" },
                    { name: "Conversions", value: "conversion_numerator_units" },
                    { name: "Counted Attempts", value: "conversion_denominator_units" },
                ],
                contacts: [
                    { name: "Count of Contacts Created", value: "contacts" },
                ],
                houses: [{ name: "Count of Houses Created", value: "houses" }],
                issues: [
                    {
                        name: "Count of Follow-Up Requests Created",
                        value: "issues",
                    },
                ],
            };

            this.dataProvider
                .getDataTableColumns()
                .then((columns: any): void => {
                    this.tableColumns = columns;
                    this.dataProvider.migrateOldColumnsToNew(
                        this.widget,
                        this.tableColumns
                    );
                });

            CanvassStatusDataProvider.walkCanvassStatuses().then(
                (statuses: CanvassStatus[]) => {
                    this.canvassStatuses = statuses;

                    angular.forEach(this.canvassStatuses, (status) => {
                        this.statsDataTypes.interactions.push({
                            name: status.name + " Interactions",
                            value: "interaction_status_" + status.id,
                        });
                    });

                    this.permissionProvider.getFeaturePermissions().then(() => {
                        const goAppEnabled = this.permissionProvider.hasPermission("GO_APP");
                        if (goAppEnabled) {
                            this.statsDataTypes.interactions.push({
                                name: "Answered Interactions (Go App)",
                                value: "interaction_status_" + 7,
                            });
                            this.statsDataTypes.interactions.push({
                                name: "Not Interested Interactions (Go App)",
                                value: "interaction_status_" + 8,
                            });
                        }
                        this.statsDataTypes.interactions.push(
                            ...newContactsStatsOptions(this.canvassStatuses, goAppEnabled)
                        );
                    });
                }
            );

            this.$scope.$on("$locationChangeStart", (e) => {
                e.preventDefault();
                this.cancel();
            });
        }

        $onInit() {
            if (!this.widget) {
                this.widget = new DashboardWidget();
                this.widget.style.colorPalette = this.chartHelper.palettes[0];
            } else {
                this.originalWidget = angular.copy(this.widget);
            }
            if (
                this.dashboard.location == "user" &&
                this.globalFilter &&
                this.globalFilter.users
            ) {
                this.widget.filter.users = this.globalFilter.users;
            }
        }

        toggleFiltersOpen() {
            this.filtersOpen = !this.filtersOpen;
        }

        dataTypeChanged(dataType: string): void {
            this.widget.groupby = null;
            if (this.widget.type == "stats") {
                this.widget.filter.selected = [];
                angular.forEach(this.statsDataTypes[dataType], (obj: { value: string }) => {
                    if (!isNewContactsMetric(obj.value)) {
                        this.widget.filter.selected.push(obj.value);
                    }
                });
            }
            if (this.widget.type == "table") {
                if (dataType == "fields") {
                    this.widget.style.tableOptions.columns = null;
                    if (this.widget.columnsField) {
                        this.fieldChanged("column");
                    }
                } else {
                    this.widget.style.tableOptions.columns = angular.copy(
                        this.tableColumns[this.widget.datatype]
                    );
                }
            }
        }

        fieldChanged(field: string): void {
            if (field === "column") {
                this.updateFieldOptions(this.widget.columnsField, "columns");
            } else if (this.widget.rowsField) {
                this.updateFieldOptions(this.widget.rowsField, "rows");
            }
        }

        updateFieldOptions(field: string, targetKey: string): void {
            if (!field) return;
            if (field.indexOf("customfield-") > -1 || field == "party") {
                this.fieldDataProvider
                    .getFieldValues(field)
                    .then((data: any): void => {
                        let formatted = data.map((value: string) => {
                            return {
                                id: value,
                                name: value,
                                tooltip: null,
                                selected: true,
                            };
                        });

                        this.updateWidgetOptions(formatted, targetKey);
                    });
            } else {
                this.updateWidgetOptions(
                    angular.copy(
                        this.fieldDataProvider.fieldTableColumns[field]
                    ),
                    targetKey
                );
            }
        }

        updateWidgetOptions(fields, targetKey: string): void {
            this.widget.style.tableOptions[targetKey] = fields;
            if (targetKey === "columns") {
                this.widget.style.tableOptions.columns.push({
                    id: "total",
                    name: "Total",
                    tooltip: null,
                    selected: true,
                });
            }

            this.widget.groupby = this.widget.rowsField
                ? `${this.widget.columnsField}, ${this.widget.rowsField}`
                : `${this.widget.columnsField}`;
        }

        visualizationTypeChanged(type: string): void {
            this.widget.groupby = null;
            this.widget.overtime = 0;
            this.widget.style.tableType = "standard";
            this.widget.datatype = this.isLeaderView ? "users" : "lists";
            if (this.widget.filter && this.widget.filter.order) {
                this.widget.filter.order.column = "title";
            }
            if (type == "table") {
                this.tableTypeChanged(this.widget.style.tableType);
            } else if (type == "activity") {
                this.widget.filter.dataTypeSpecificFilter =
                    new ActivityFilter();
            } else {
                this.widget.datatype = "interactions";
                this.dataTypeChanged(this.widget.datatype);
            }
        }

        chartTypeChanged(chartType: string): void {
            if (chartType == "pie" || chartType == "donut") {
                this.widget.overtime = 0;
            }
        }

        tableTypeChanged(tableType: string): void {
            if (tableType == "pivot") {
                this.widget.datatype = "fields";
            } else {
                this.widget.datatype = this.isLeaderView ? "users" : "lists";
            }
            this.dataTypeChanged(this.widget.datatype);
        }

        toggle(item: string, list: any[], isStatus: any) {
            let needle: string = angular.copy(item);
            if (isStatus) {
                needle = "interaction_status_" + item;
            }
            const idx: number = list.indexOf(needle);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(needle);
            }
        }

        exists(item: string, list: string | any[], isStatus: any) {
            let needle: string = angular.copy(item);
            if (isStatus) {
                needle = "interaction_status_" + item;
            }
            return list.indexOf(needle) > -1;
        }

        expandCategory(category): void {
            category.expanded = !category.expanded;
        }

        next(): void {
            this.step += 1;
        }

        confirm(): void {
            this.saving = true;
            if (this.dashboard && this.dashboard.id) {
                this.widget.dashboardid = this.dashboard.id;
            }
            if (this.widget.id) {
                this.dataProvider.updateWidget(this.widget).then(
                    (widget: any): void => {
                        this.dialog.hide(widget);
                    },
                    (error: any): void => {
                        this.saving = false;
                    }
                );
            } else {
                this.dataProvider.createWidget(this.widget).then(
                    (widget: any): void => {
                        this.dialog.hide(widget);
                    },
                    (error: any): void => {
                        this.saving = false;
                        console.log(error);
                    }
                );
            }
        }

        changesHaveBeenMade() {
            if (this.widget.id) {
                let widget: DashboardWidget = angular.copy(this.widget);
                let originalWidget: DashboardWidget = angular.copy(
                    this.originalWidget
                );
                //The dates can be updated by seconds/minutes when open edit dialog, and shouldn't be included in comparison
                delete widget.filter.dateRange.dateStart;
                delete widget.filter.dateRange.dateEnd;
                delete originalWidget.filter.dateRange.dateStart;
                delete originalWidget.filter.dateRange.dateEnd;

                return JSON.stringify(originalWidget) != JSON.stringify(widget);
            } else {
                return (
                    (this.widget.name && this.widget.name != "") ||
                    this.widget.type
                );
            }
        }

        cancel(ev?: any): void {
            if (this.changesHaveBeenMade()) {
                this.dialog
                    .show({
                        component: "vc-unsaved-changes-dialog",
                        size: "small",
                        targetEvent: ev,
                        scope: this.$scope,
                        locals: {},
                    })
                    .then(() => {
                        this.dialog.cancel();
                    });
            } else {
                this.dialog.cancel();
            }
        }
    },
};

angular
    .module("dashboard")
    .component(CreateWidgetComponent.selector, CreateWidgetComponent);
